import Vue from "vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
Vue.component("vue-google-autocomplete", VueGoogleAutocomplete);
